export const ALL_LABEL = 'All';
export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const USER = 'User';
export const SEARCH = 'Search';
export const TARGET_BLANK = '_blank';
export const ENABLED = 'Enabled';
export const DISABLED = 'Disabled';
export const CONTINUE_SETUP = 'Continue Setup';
export const LEAVE_WITHOUT_SAVING = 'Leave Without Saving';
export const CLEAR = 'Clear';
export const SELECTED = 'Selected';
export const REASSIGN = 'Reassign';
export const PRINT_DETAILS = 'Print Details';
export const ADD_TO_ITINERARY = 'Add to Itinerary';
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const SELECT = 'Select';
export const ASSIGNED_TO = 'Assigned To';
export const GROUP_BY = 'Group By';
export const SORT_BY = 'Sort By';
export const NEW = 'New';
export const SHOW = 'Show';
export const HIDE = 'Hide';
export const ERROR_OCCURRED_ERROR_MESSAGE = 'An error occurred. Please try again.';
export const REQUEST_PROCESSING_ERROR_MESSAGE = 'There is a problem processing the request. Please try again';
export const DOUBLE_HYPHEN = '--';
export const PDF_THUMBNAIL = '(pdf-thumb).png';
export const STAY_HERE = 'Stay Here';
export const DONT_SAVE = "Don't Save";
export const ERROR = 'Error';
export const RETURN_TO_JOB_OVERVIEW_BUTTON_LABEL = 'Return to Job Overview';
export const EMPTY_TEXT = '';
export const AUDATEX_LABEL = 'Audatex';
export const PRIMARY = 'Primary';
export const SECONDARY = 'Secondary';
export const SETTINGS = 'Settings';
export const DELETE = 'Delete';
export const DUE_DATE = 'Due Date';
export const SET_DATE = 'Set Date';
export const YES_TYPE = 'Y';
export const NO_TYPE = 'N';
export const IN_NETWORK_TYPE = 'INNETWORK';
export const NA_TYPE = 'NA';
export const DAYS = 'days';
export const MONTHS = 'months';
export const ASSISTANCE_MODAL_TITLE = 'Unsaved Changes';
export const ASSISATNCE_MODAL_MESSAGE = 'You have unsaved changes. Do you want to save your changes before leaving the page?';
export const AND = 'and';
export const OK = 'Ok';
export const UPDATING = 'Updating';
export const DONE_LABEL = 'Done';
export const CANCEL_LABEL = 'Cancel';
export const DATE = 'Date';
export const SELECT_PLACEHOLDER = '-Select-';
export const WE_HAVE_ENCOUNTERED_PROBLEM = 'We have encountered internal server error. Please try again later.';
export const ASSIGN_USERS = 'ASSIGN USERS';
export const TAB_ID_KEY = 'tabId';
// TODO - Doesnt look like an actual constant and should be moved to common functions instead of constant
export const newJobSoonAvailableNotification = (claimNumber) => `A Job for Claim ${claimNumber} will be created within a few minutes.`;
export const ADDITIONAL_INFORMATION_LABEL = 'Additional Information';
export const SAVE_LABEL = 'Save';
export const USER_APP_CODE = 'userAppCode';
export const NO_OPTIONS_MESSAGE = 'No options';
export const LOADING_MESSAGE = 'Loading...';
export const MORNING = 'Morning';
export const AFTERNOON = 'Afternoon';
export const YES_LABEL = 'Yes';
export const NO_LABEL = 'No';
export const APPLY = 'Apply';
export const TECHNICIAN = 'Technician';
export const LABOR_TYPE = 'Labor Type';
export const SELECT_TECHNICIAN = 'Select Technician';
export const SELECT_LABOR_TYPE = 'Select Labor Type';
export const NO_TECHNICIANS_FOUND = 'No technicians found';
export const TECHNICIAN_SELECT_ID = 'technician-select';
export const LABOR_TYPE_SELECT_ID = 'labor-type-select';
export const APPLY_BUTTON_TEST_ID = 'apply-button';
export const LABOR = 'LABOR';
export const DUE_OUT_DATE_RANGE = 'Due Out Date Range';
//# sourceMappingURL=GenericConstants.js.map